export const MelanauMenCostLis  = [ 
    {
        name:"Baju Bakuas",
        img_src:" ",
        description:"Baju Bajuas is a traditional wedding attire worn by the groom. The wedding attire consists of a kain samping called 'bidek lugik, a belt called 'pending', songkok as a headwear, and 'bunga tajuk' as accessories. A keris, which symbolises protection against evil spirits, completes the whole look. ",
        url: "baju-bakuas"
    }, 

    {
        name: "Baju Lelaki Melanau", 
        img_src: " https://66.media.tumblr.com/3a313a4501c723048f3a3eb778a2f4b6/3cb1841f8c84fc7c-6a/s540x810/d96a1b6d570dfd07b1125f85c13ddfad444a6a1f.png", 
        description: "The Melanau traditional outfit is usually made with satin and is black in colour. There are several accessories which completes the whole look namely, Rantai Air Luji, and Bulaeng.", 
        url: "baju-lelaki-melanau", 

    }, 

    {
        name:"Bulaeng", 
        img_src: "https://66.media.tumblr.com/16c7acd2b30df92adac2b3947dd3b8d8/3cb1841f8c84fc7c-a3/s540x810/4e286c640a0d6e187e73953e8df1c98087fa7f26.png ", 
        description: " Bulaeng is a piece of headscarf for men. It is similar to the Javanese headwear. Bulaeng essentially completes the Melanau traditional attire. The Melanau community in Kampung Telian still uses the Bulaeng. ", 
        url: "bulaeng"
    }, 

    {
        name: "Rantai Air Luji", 
        img_src: "https://66.media.tumblr.com/a9e64ed7e780c602e5ccce4f98700ab3/3cb1841f8c84fc7c-fa/s540x810/c801f2660b42f0d11c2a68c8dcd004a9455cf95d.png ",
        description: "Rantai Air Luji is an accessory worn with the Baju Kout Kancing 7. It is made of silver.", 
        url: "rantai-air-luji"
    },

    

]; 

export const MelanauWomenCostList = [
    {
        name: "Serbang", 
        img_src: "https://66.media.tumblr.com/b750028032ddf9768d375a8db44031ab/513bd3b28454b024-ee/s540x810/8915aed1d222530a7940d55fdc1f52cad0854c42.png ",
        description:"Serbang is a headgear worn by the bride on her wedding day. Serbang comes in variety of designs and is made out of silver.", 
        url: "serbang"
    },

    {
        name: "Baju Baban Lasoung",
        img_src: "https://66.media.tumblr.com/bfa4d7d2c59d4d56dc8e78c38bcc8a7b/3cb1841f8c84fc7c-19/s540x810/2bfa412320caea60a79aebebab14075410d980d1.png ",
        description: "Baban Lasoung is a Melanau Women's traditional costume. The name 'baban lasoung' comes from the copper buttons 'buak baban lasoung'. The difference between Baju Baban Lasoung and Baju Baban Pipaeng is on the embroidered songket on the Baban Pipang's neck area. ", 
        url:"baju-baban-lasoung"
    },

    {
        name: "Baju Baban Pipaeng",
        img_src:" https://66.media.tumblr.com/7a401f6aa3b2e7773a275a68b1cbb22a/cde0cbbdff35659a-73/s540x810/5c2f9710cdcb775f4dbe061278d0eb5cccc621b1.png",
        description:" Baju Baban Pipaeng is a Melanau Women's traditional costume. The shirt is usually worn with “Jiner”, an embroidered red piece of cloth around the neck. The wealthy would represent their status with a Songkot draped over their  shoulder.   ",
        url:"baju-baban-pipaeng"
    }, 

    {
        name: "Buak Baban Lasoung",
        img_src: " https://66.media.tumblr.com/a80b5bb823c714807c720e93b8f42cbc/513bd3b28454b024-93/s540x810/4f36fe014e3887c3fcff3150ad96d09c806b046f.png",
        description: " Buak Baban Lasoung are essentially buttons for the traditional Baban outfit. Originally the Buak Baban is made out of silver and gold. But nowadays, it is usually made from copper. ", 
        url:"buak-baban-lasoung"
    }, 

    {
        name: "Gelang Rukaed Pineang", 
        img_src: "https://66.media.tumblr.com/519ec31f870d888f76e21cec396ceb6a/513bd3b28454b024-0a/s540x810/e21eb0532c412581c32bfbaa31f14ac8aa1cc494.png ",
        description: "Gelang Rukaed Pineang is a bracelet made of gold-plated brass. The traditional accessory essentially completes the look of the women wearing baju kurung batik lama / baju kebaya panjang / baju baban.", 
        url:"gelang-rukaed-pineang"
    }, 
    
    {
        name: "Cerucuk Sanggul", 
        img_src: "https://66.media.tumblr.com/d1dbb1b59b6ee060c6d12d6af9cdf91e/513bd3b28454b024-b1/s540x810/68e6813c36d28f28ac9f646fceb1f72728aef3ee.png ",
        description: "Cerucuk Sanggul is a hair-piece that keeps the women's hair up. It is one the accossories that complete the Melanau traditional outfit look. It is made of gold-plated brass.",
        url:"cerucuk-sanggul"
    }, 

    {
        name: "Gelang Aluk-Aluk & Gelang Paek",
        img_src: "https://66.media.tumblr.com/69ecdd4b532e8b6c0c9264e8beb0ce8b/513bd3b28454b024-17/s540x810/285f851670627476731ade894a40707dd97d40c5.png ",
        description: "Gelang Aluk-Aluk are bracelets worn by brides on their wedding day. The bride would put on as many as 6 pairs of Aluk-Aluk braelets along with a pair of Paek bracelets depending on the size of the bride's arm." , 
        url: "gelang-aluk-aluk-gelang-paek"
    }, 
    
    {
        name: " Keronsang Telur Ikan / Teloh Jekan",
        img_src: "https://66.media.tumblr.com/4c492101432d3252adfb46690a900900/513bd3b28454b024-0b/s540x810/7a34e6f23a1b5343bfaf264b65361f62609e7edd.png",
        description: " A 'Keronsang' can be literally translated as a brooch. It may come in a variety of design. The picture depicts a particular design called Keronsang Telur Ikan. Melanau women worn the 'keronsang' to accessorise their baju kurung or batik. ",
        url: "keronsang-telur-ikan"
    }, 

    {
        name: "Pakaian Mulid",
        img_src: " https://66.media.tumblr.com/c320eed9b52ddb7a6c4a17a41dfc6a8d/513bd3b28454b024-01/s540x810/6349eb7c8ce6cab159694eda8aff8329c9f84eb1.png",
        description: "Pakaian Mulid is a dress used by melanau women to mourn when they’ve lost their loved ones. Women Melanau will wear the outfit with Terindek laud.  the mourning period takes approximately 15 months.",
        url: "pakaian-mulid "
    }, 

    {
        name: "Bidek Siantan",
        img_src: "https://66.media.tumblr.com/b4650dc5df8bcdf16c9aa8fa4fbcd2d7/ad5cf72e564ac468-35/s540x810/5bcee60c4fd27d2d8978f4e7340b97edb2cef0e6.png ",
        description:  "Bidek Siantan is a songket with embroidered pineapple pattern. The pattern symbolised the women's wealth an status. It was said that the design on Bidek Siantan is highly influenced by the culture of the people of Brunei as Mukah, a region in Sarawak, used to be a Brunei colony.",
        url:"bidek-siantan"
    }, 
    
]; 
